/** Value with which the controller signals "not available". */
export const SOLAR_VALUE_INVALID = 255;

/** Status of the solar controller, bitwise coded: bit 0 = warning, bit 1 = error. */
export enum SolarStatusType {
    Ok = 0,
    Warnung = 1,
    Fehler = 2,
    WarnungUndFehler = 3,
    Ungueltig = SOLAR_VALUE_INVALID,
}

export function getSolarStatusTypeString(type: SolarStatusType): string {
    switch (type) {
        case SolarStatusType.Ok:
            return 'Ok';
        case SolarStatusType.Warnung:
            return 'Warnung';
        case SolarStatusType.Fehler:
            return 'Fehler';
        case SolarStatusType.WarnungUndFehler:
            return 'Warnung + Fehler';
        case SolarStatusType.Ungueltig:
            return 'Ungültig';
        default:
            return String(type);
    }
}
